"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TIER_PRICING = void 0;
var TIER_PRICING = {
  TIERS: {
    BUTTON__ADD: 'tierPricing-button-addTierPricing',
    BUTTON__OPTIONS: 'tierPricing-button-options',
    BUTTON__EDIT: 'tierPricing-button-editTierPricing',
    BUTTON__DELETE: 'tierPricing-button-deleteTierPricing',
    BUTTON__DELETE_CANCEL: 'tierPricing-button-deleteTierPricingCancel',
    BUTTON__DELETE_CONFIRM: 'tierPricing-button-deleteTierPricingConfirm',
    TIER_PREVIEW: {
      TEXT__QUANTITY: 'tierPricingPreview-span-quantity',
      TEXT__PRICE: 'tierPricingPreview-span-price'
    },
    TIERS_MODAL: {
      LABEL__SET_PRICE: 'addTierPricingModal-label-setPrice',
      LABEL__SET_DISCOUNT: 'addTierPricingModal-label-setDiscount',
      BUTTON__ADD_TIER: 'addTierPricingModal-button-addTier',
      BUTTON__REMOVE_TIER: 'addTierPricingModal-button-removeTier',
      INPUT__NUMBER_OF_PRODUCTS: 'addTierPricingModal-input-numberOfProducts',
      INPUT__VALUE: 'addTierPricingModal-input-value',
      BUTTON__CANCEL: 'addTierPricingModal-button-cancel',
      BUTTON__SAVE: 'addTierPricingModal-button-save'
    }
  },
  SPECIAL_TIERS: {
    BUTTON__ADD: 'tierPricing-button-addSpecialTierPricing',
    BUTTON__OPTIONS: 'tierPricing-button-specialTierPricingOptions',
    BUTTON__EDIT: 'tierPricing-button-editSpecialTierPricing',
    BUTTON__DELETE: 'tierPricing-button-deleteSpecialTierPricing',
    BUTTON__DELETE_CANCEL: 'tierPricing-button-deleteSpecialTierPricingCancel',
    BUTTON__DELETE_CONFIRM: 'tierPricing-button-deleteSpecialTierPricingConfirm',
    TEXT__SPECIAL_TIER_NAME: 'tierPricing-span-specialTierPricingName',
    SPECIAL_TIER_PREVIEW: {
      TEXT__QUANTITY: 'specialTierPricingPreview-span-quantity',
      TEXT__PRICE: 'specialTierPricingPreview-span-price'
    },
    SPECIAL_TIERS_MODAL: {
      INPUT__NAME: 'addSpecialTierPricingModal-input-tierName',
      LABEL__SET_PRICE: 'addSpecialTierPricingModal-label-setPrice',
      LABEL__SET_DISCOUNT: 'addSpecialTierPricingModal-label-setDiscount',
      BUTTON__ADD_TIER: 'addSpecialTierPricingModal-button-addTier',
      BUTTON__REMOVE_TIER: 'addSpecialTierPricingModal-button-removeTier',
      INPUT__NUMBER_OF_PRODUCTS: 'addSpecialTierPricingModal-input-numberOfProducts',
      INPUT__VALUE: 'addSpecialTierPricingModal-input-value',
      TEXT__OUTLET: 'addSpecialTierPricingModal-span-outletName',
      BUTTON__CANCEL: 'addSpecialTierPricingModal-button-cancel',
      BUTTON__SAVE: 'addSpecialTierPricingModal-button-save',
      INPUT__OUTLET_SEARCH: 'addSpecialTierPricingModal-input-search',
      BUTTON__OUTLET_RESULT: 'addSpecialTierPricingModal-button-outletResult',
      TEXT__OUTLET_RESULT_NAME: 'addSpecialTierPricingModal-span-outletResultName',
      TEXT__SELECTED_OUTLET: 'addSpecialTierPricingModal-span-selectedOutlet',
      BUTTON__REMOVE_SELECTED_OUTLET: 'addSpecialTierPricingModal-button-removeSelectedOutlet'
    }
  }
};
exports.TIER_PRICING = TIER_PRICING;